// ©2024 Austin App House. All rights reserved.
import React from "react";
import FilePreview from "./FilePreview";
import { Results } from "./FileUploadStyled";


const FileListUpload = ({name, files = [], handleDelete}) => {
    return (
        <div className='field_row'>
        <Results
            className="certificates-file-grid"
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "10px",
                alignItems: "start"
            }}
        >
            {files.map((file, index) =>
                <FilePreview key={`${name}-${index}-${Date.now()}`} file={file} onDelete={handleDelete}/>
            )}
        </Results>
        </div>
    )
}

export default FileListUpload